import React, { useRef, useMemo } from "react";

import { IconButton } from "@mui/material";
import { Printer } from "iconsax-react";
import { useQuery } from "@tanstack/react-query";

import DiaryPrintReport, { IDiaryPrintReportHandle } from "../../popups/DiaryPrintReport";
import { useAppState } from "Context/StateContext";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { Status } from "Util/enums";
import { BranchKeys } from "Util/queries";
import BranchService from "Services/branch.service";

export const DiaryPrintReports = () => {
  const { currentUser } = useAppState();
  const { companyId } = useOperationDespatchContext();

  const diaryPrintReportRef = useRef<IDiaryPrintReportHandle>(null);

  const { data: branchList, isFetching } = useQuery({
    queryKey: BranchKeys.getAll([companyId]),
    queryFn: () =>
      BranchService.getAll({
        companyId,
        status: Status.ACTIVE,
        include: JSON.stringify([
          { association: "users", where: { id: currentUser?.id! } },
          { association: "company", attributes: ["id", "name"] },
        ]),
      }).then((res) => res.data || []),
  });

  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => {
          diaryPrintReportRef.current?.open();
        }}
      >
        <Printer size="24" color="#000000CC" />
      </IconButton>
      <DiaryPrintReport
        ref={diaryPrintReportRef}
        disabled={!currentUser}
        branches={branchList}
        isFetchingBranchList={isFetching}
      />
    </>
  );
};
